import React from "react";
import classes from "./Card.module.scss";

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

const Card: React.FC<CardProps> = ({ children, className = "" }) => {
  return (
    <div className={`${classes.card} ${className}`}>
      {children}
    </div>
  );
};

export default Card;
